import { render, staticRenderFns } from "./PageBlogPosts.vue?vue&type=template&id=47f43c50&"
import script from "./PageBlogPosts.vue?vue&type=script&lang=js&"
export * from "./PageBlogPosts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/digital-seaside/sst-admin-panel/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('47f43c50')) {
      api.createRecord('47f43c50', component.options)
    } else {
      api.reload('47f43c50', component.options)
    }
    module.hot.accept("./PageBlogPosts.vue?vue&type=template&id=47f43c50&", function () {
      api.rerender('47f43c50', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/blogPosts/PageBlogPosts.vue"
export default component.exports